import type { AppCategory } from "../models/Category";
import type { TreeNode } from "../models/AppLocation";

export function buildCategoryTree(flat: AppCategory[]): TreeNode[] {
    const byId = new Map<number, TreeNode>();
    const childrenByParent = new Map<number | null, TreeNode[]>();
    for (const c of flat) {
        const node: TreeNode = { id: String(c.id), label: c.name, _locId: c.id, children: [] };
        byId.set(c.id, node);
        const k = c.parentId ?? null;
        const arr = childrenByParent.get(k) ?? [];
        arr.push(node);
        childrenByParent.set(k, arr);
    }
    for (const [pid, kids] of childrenByParent.entries()) if (pid !== null) byId.get(pid)!.children = kids;
    const roots: TreeNode[] = [];
    for (const c of flat) if (c.parentId == null || !byId.has(c.parentId)) roots.push(byId.get(c.id)!);
    const sortRec = (ns?: TreeNode[]) => { if (!ns) return; ns.sort((a, b) => a.label.localeCompare(b.label)); ns.forEach(n => sortRec(n.children)); };
    sortRec(roots);
    return roots;
}